module.exports = __webpack_public_path__ + "img/Frame-77.f13f5d0b.svg";